import React from 'react';
import { Icon } from './Icon.js';
export const IconArchiveBookmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 15H7.5L8.5 17H15.5L16.5 15H21", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 3L3 3L3 21L21 21L21 15", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 3H21V10.5L18 9L15 10.5V3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconArchiveBookmark.js.map